
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/supplier-faq",
      function () {
        return require("private-next-pages/supplier-faq/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/supplier-faq"])
      });
    }
  